<template>
  <div>
    <div class="mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <b-alert
          v-if="selectedGuide"
          class="w-100 mr-1 mb-0"
          show
          variant="info"
        >
          <div class="alert-body">
            <strong>{{ $t('tasks.add.selectedGuide') }}</strong> {{ selectedGuide.title }}
          </div>
        </b-alert>
        <b-button
          variant="outline-secondary"
          size="sm"
          class="text-nowrap"
          @click="selectGuideModalVisible = true"
        >
          <feather-icon icon="BookOpenIcon" />
          {{ $t('tasks.add.selectGuide') }}
        </b-button>
      </div>
    </div>
    <validation-observer ref="simpleRules">
      <tasks-item-form />
      <save-button
        :save-action="submitForm"
        :is-disabled="submitStatus"
      />
    </validation-observer>

    <select-guide-modal
      v-model="selectGuideModalVisible"
      :get-guide-data="getGuideData"
    />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { BButton, BAlert } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import TasksItemForm from '@/views/Tasks/ItemForm.vue'
import SelectGuideModal from '@/views/Tasks/Components/SelectGuideModal.vue'

export default {
  name: 'Add',
  components: {
    TasksItemForm,
    ValidationObserver,
    SaveButton,
    BAlert,
    BButton,
    SelectGuideModal,
  },
  data: () => ({
    submitStatus: false,
    selectGuideModalVisible: false,
    selectedGuide: null,
  }),
  computed: {
    itemData() {
      return this.$store.getters['tasks/dataItem']
    },
    guides() {
      return this.$store.getters['guides/dataItem']
    },
    subtasks() {
      return this.$store.getters['subtasks/dataList']
    },
    saveData() {
      return this.$store.getters['tasks/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val?.watcherError) {
        this.showToast({
          variant: 'warning', title: this.$t('common.toast.warning'), icon: 'AlertTriangleIcon', text: this.$t('tasks.form.watcherError'),
        })
      }
      if (val?.status === true) {
        this.showToast({
          variant: 'success',
          title: this.$t('common.toast.success'),
          icon: 'CheckIcon',
          text: this.$route.query.id_guides ? this.$t('tasks.add.createdFromGuide') : val.message,
        })
        this.$router.push(`/app/tasks/edit/${val.id}`)
      } else if (val?.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
    },
  },
  created() {
    this.getGuideData()
  },
  methods: {
    getGuideData() {
      if (this.$route.query.id_guides) {
        this.$store.commit('tasks/RESET_DATA_ITEM')
        this.$store.dispatch('guides/getDataItem', this.$route.query.id_guides)
          .then(res => {
            if (res) {
              if (res.title) {
                this.selectedGuide = res
                this.itemData.title = `${res.title} (Kopya)`
                this.itemData.description = res.description
                this.itemData.id_departments = res.id_departments
                this.itemData.id_teams = res.id_teams
                if (this.itemData.id_departments) {
                  this.$store.commit('teams/RESET_DATA_LIST')
                  this.$store.dispatch('teams/getDataList', {
                    select: [
                      'teams.id AS id',
                      'teams.title AS title',
                    ],
                    where: {
                      'teams.id_departments': this.itemData.id_departments,
                    },
                  })
                }
              }
            }
          })
        this.selectGuideModalVisible = false
      } else {
        this.$store.commit('tasks/RESET_DATA_ITEM')
      }
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          if (this.$route.query.id_guides) {
            this.itemData.id_guides = this.$route.query.id_guides
          }
          this.$store.dispatch('tasks/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'), icon: 'XIcon', text: this.$t('common.requiredFields'), variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({ component: ToastificationContent, props: params }, { position: 'bottom-center' })
    },
  },
}
</script>
